"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _AccordionItemHeading = _interopRequireDefault(require("./AccordionItemHeading"));

var _AccordionItemContent = _interopRequireDefault(require("./AccordionItemContent"));

require("./AccordionItem.scss");

var _uuid = _interopRequireDefault(require("uuid"));

var _reactCollapse = require("react-collapse");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  /** A unique id provided to each item by the parent component.
   * Used on the accordion heading with a matching aria-describedby on the content. */
  id: _propTypes.string.isRequired,

  /** Set to true if you want the panel to be open by default */
  expanded: _propTypes.bool,

  /** Use `<AccordionItemHeading/>` and `<AccordionItemContent/>` as children
   * to control the heading and content */
  children: _propTypes.node,

  /** Callback function for click on the heading */
  onClick: _propTypes.func,

  /** Add your own custom class names to the component */
  className: _propTypes.string,
  renderActiveContentOnly: _propTypes.bool,

  /** Choose the color of the chevron */
  chevronColor: (0, _propTypes.oneOf)(['info', 'dark'])
};
var defaultProps = {
  expanded: false
};
/** The AccordionItem is used as a child (or children) of the Accordion component.
 * @visibleName Accordion Item
 * */

var AccordionItem = /*#__PURE__*/function (_Component) {
  _inherits(AccordionItem, _Component);

  var _super = _createSuper(AccordionItem);

  function AccordionItem(props) {
    var _this;

    _classCallCheck(this, AccordionItem);

    _this = _super.call(this, props);
    _this.contentId = "rds-accordion-item-content-".concat(_uuid.default.v4());
    return _this;
  }

  _createClass(AccordionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          id = _this$props.id,
          renderActiveContentOnly = _this$props.renderActiveContentOnly,
          className = _this$props.className,
          chevronColor = _this$props.chevronColor;
      var expanded = this.props.expanded;
      var accordionItemHeading = children.find(function (i) {
        return i.type === _AccordionItemHeading.default;
      });
      var accordionItemContent = children.find(function (i) {
        return i.type === _AccordionItemContent.default;
      });
      var componentClassNames = (0, _classnames.default)('rds-accordion-item', {
        'rds-accordion-item--expanded': expanded
      }, className);
      var ReactCollapseWrapper = renderActiveContentOnly ? _reactCollapse.UnmountClosed : _reactCollapse.Collapse;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassNames
      }, /*#__PURE__*/_react.default.cloneElement(accordionItemHeading, {
        expanded: expanded,
        id: id,
        contentId: this.contentId,
        onClick: onClick,
        chevronColor: chevronColor
      }), /*#__PURE__*/_react.default.createElement(ReactCollapseWrapper, {
        isOpened: expanded,
        springConfig: {
          stiffness: 300
        }
      }, /*#__PURE__*/_react.default.cloneElement(accordionItemContent, {
        expanded: expanded,
        id: id,
        contentId: this.contentId
      })));
    }
  }]);

  return AccordionItem;
}(_react.Component);

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
var _default = AccordionItem;
exports.default = _default;